module.exports = __webpack_public_path__ + "./docs/img/icon-method.814859c68a666a283e4558a0961e8460.svg";